import apiService from "../../../service/Api";
import type {
  AddLineItemPayload,
  CostAnalysisDetail,
  SubmitTarget,
} from "./cost-analysis";

// TODO: move these payload types into ./cost-analysis.ts, next to
// AddLineItemPayload, once that file's on hand - kept local here so this
// compiles standalone in the meantime.
export interface UpdateLineItemPayload {
  label: string;
  amount: number;
  detail?: string | null;
}

export interface AddCrewPaymentPayload {
  crew_member_id: number;
  role_id: number;
}

export async function fetchCostAnalysis(
  streamId: number | string,
): Promise<CostAnalysisDetail> {
  const res = await apiService.get<CostAnalysisDetail>(
    `/api/cost-analysis/cost-analyses/by-stream/${streamId}/`,
  );
  return res.data;
}

export async function recalculateCostAnalysis(
  id: number | string,
): Promise<CostAnalysisDetail> {
  const res = await apiService.post<CostAnalysisDetail>(
    `/api/cost-analysis/cost-analyses/${id}/recalculate/`,
  );
  return res.data;
}

export async function addLineItem(
  id: number | string,
  payload: AddLineItemPayload,
): Promise<CostAnalysisDetail> {
  const res = await apiService.post<CostAnalysisDetail>(
    `/api/cost-analysis/cost-analyses/${id}/add-line-item/`,
    payload,
  );
  return res.data;
}

export async function updateLineItem(
  id: number | string,
  itemId: number,
  payload: UpdateLineItemPayload,
): Promise<CostAnalysisDetail> {
  const res = await apiService.patch<CostAnalysisDetail>(
    `/api/cost-analysis/cost-analyses/${id}/line-items/${itemId}/`,
    payload,
  );
  return res.data;
}

export async function deleteLineItem(
  id: number | string,
  itemId: number,
): Promise<CostAnalysisDetail> {
  const res = await apiService.delete<CostAnalysisDetail>(
    `/api/cost-analysis/cost-analyses/${id}/line-items/${itemId}/`,
  );
  return res.data;
}

export async function addCrewPayment(
  id: number | string,
  payload: AddCrewPaymentPayload,
): Promise<CostAnalysisDetail> {
  const res = await apiService.post<CostAnalysisDetail>(
    `/api/cost-analysis/cost-analyses/${id}/add-crew-payment/`,
    payload,
  );
  return res.data;
}

export async function submitCostAnalysis(
  id: number | string,
  target: SubmitTarget,
): Promise<CostAnalysisDetail> {
  const res = await apiService.post<CostAnalysisDetail>(
    `/api/cost-analysis/cost-analyses/${id}/submit/`,
    { submitted_to: target },
  );
  return res.data;
}

export async function requestCostAnalysisReopen(
  id: number | string,
  reason = "",
): Promise<CostAnalysisDetail> {
  const res = await apiService.post<CostAnalysisDetail>(
    `/api/cost-analysis/cost-analyses/${id}/request-reopen/`,
    { reason },
  );
  return res.data;
}
